import React, { useState } from 'react';
import styles from './styles.module.css';

const Tooltip = ({ title, children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={styles.container}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && <div className={styles.content}>{title}</div>}
    </div>
  );
};

export default Tooltip;
